import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Alert } from 'antd';

import { changePassword } from '../../actions/Authentication';

class Settings extends Component {

    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            errorMessage: ''
        }
    }

    submitForm(values) {
        console.log(values);
        const { currentPassword, newPassword } = values;
        this.props.changePassword({ password: currentPassword, newPassword }, (errorMessage) => {
            if (errorMessage) {
                this.setState({ hasError: true, errorMessage })
            } else {
                this.props.history.replace('/settings');
            }
        });
    }

    renderField(field) {
        const { meta: { touched, error }, input, placeholder, label, value, htmlFor } = field;
        const className = `form-group input-txt ${touched && error ? 'input-error' : ''}`;

        return (
            <div className={className}>
                <label htmlFor={htmlFor}>{label}</label>
                <input className="form-control" type="password" id={htmlFor} placeholder={placeholder} {...input} />
                <span className="error-message">{touched ? error : ''}</span>
            </div>
        );
    }

    renderError() {
        if (this.state.hasError) {
            return (
                <Alert
                    message={this.state.errorMessage}
                    type="error"
                />
            );
        }
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <div className="main-content">
                <div className="page-title">Settings</div>
                <div className="divider"></div>
                <div className="change-password">
                    <h3>Change Password</h3>
                    <form onSubmit={handleSubmit(this.submitForm.bind(this))}>
                        <Field
                            name="currentPassword"
                            label="Current Password:"
                            placeholder="Current Password"
                            htmlFor="current-password"
                            component={this.renderField}
                        />
                        <Field
                            name="newPassword"
                            label="New Password:"
                            placeholder="New Password"
                            htmlFor="new-password"
                            component={this.renderField}
                        />
                        <Field
                            name="confirmPassword"
                            label="Confirm Password:"
                            placeholder="Confirm Password"
                            htmlFor="confirm-password"
                            component={this.renderField}
                        />
                        {this.renderError()}
                        <div className="footer-btn">
                            <button className="btn button green-btn" type="submit">Change Password</button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

const validate = (values) => {
    console.log(values);

    const errors = {};

    if (!values.currentPassword) {
        errors.currentPassword = 'Please enter current password'
    } else if (values.currentPassword.length < 6) {
        errors.currentPassword = 'Password must be 6 characters or longer'
    }

    if (!values.newPassword) {
        errors.newPassword = 'Please enter new password'
    } else if (values.currentPassword && values.newPassword) {
        if (values.newPassword.length < 6) {
            errors.newPassword = 'Password must be 6 characters or longer'
        }

        if (values.currentPassword === values.newPassword) {
            errors.newPassword = 'New password must be different';
        }
    }

    if (!values.confirmPassword) {
        errors.confirmPassword = 'Please confirm new password'
    } else if (values.newPassword && values.confirmPassword) {
        if (values.newPassword != values.confirmPassword) {
            errors.confirmPassword = 'Invalid confirm password';
        }

        if (values.confirmPassword.length < 6) {
            errors.confirmPassword = 'Password must be 6 characters or longer'
        }
    }

    return errors;
}

Settings = reduxForm({
    validate,
    form: 'AdminChangePasswordForm',
    enableReinitialize: true
})(Settings);

Settings = connect(null, { changePassword })(Settings);

export default Settings;


// WEBPACK FOOTER //
// ./src/views/settings/index.js